import { BaseActionObject, StateNodeConfig, assign } from "xstate4"
import { ActionModalSchema, Context, Transitions } from "../../types"
import { saveCancelModalState } from "../manageModals"

export const editModalState: StateNodeConfig<
  Context,
  ActionModalSchema,
  Transitions,
  BaseActionObject
> = {
  entry: assign<Context>({ openEditModal: true }),
  exit: assign<Context>({ openEditModal: false }),
  ...saveCancelModalState("#ManageUserModules.classes_page.idle", "editClass", {
    cancelTarget: "#ManageUserModules.classes_page.backToPrevious",
    loadingState: "edit",
    onSuccess: (ctx, _evt) => ({
      snackbar: {
        message: `Successfully updated ${ctx.snackbarMessageInfo}`,
        withUndo: false,
        error: false
      },
      // if details_tray is open leave the selectedClassRecord selected otherwise
      //  if the tray isn't open, unselect the record
      ...(!ctx.openDetailsTray && {
        selectedClassRecord: null
      })
    }),
    successActions: ["updateFetch"],
    onError: (ctx, _evt) => ({
      snackbar: {
        message: `An error occurred while trying to edit class ${ctx.snackbarMessageInfo}. Please try again. If the error persists, contact support for help.`,
        withUndo: false,
        error: true
      }
    })
  })
}
